const Backbone = require("backbone");
var ApiConfig = require("_lib/data/ApiConfig.js");

var ForgotPassword = Backbone.Model.extend({
  urlRoot: ApiConfig.getPrefix() + "/forgotlogin/password",
});

module.exports = ForgotPassword;
